// import { useEffect, useState, forwardRef, useRef } from "react";
// import { OrbitControls, Sphere, useVideoTexture } from "@react-three/drei";
// import * as THREE from "three";

// const VideoPanoramaViewer = forwardRef(({ videoSrc, handleOrbitChange }, orbitControlsRef) => {
//     const videoTexture = useVideoTexture(videoSrc, {
//         loop: true,
//         muted: true,
//         start: true,
//     });

//     const [isMobile, setIsMobile] = useState(false);
//     const controlsRef = useRef();

//     // Check for mobile screen
//     useEffect(() => {
//         const handleResize = () => setIsMobile(window.innerWidth <= 600);
//         handleResize();
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     // Apply inversion logic on drag for mobile
//     useEffect(() => {
//         const controls = controlsRef.current;
//         if (!controls) return;

//         const domElement = controls.domElement;

//         let lastTouch = null;

//         const onTouchStart = (e) => {
//             if (e.touches.length === 1) {
//                 const touch = e.touches[0];
//                 lastTouch = { x: touch.pageX, y: touch.pageY };
//             }
//         };

//         const onTouchMove = (e) => {
//             if (!lastTouch || e.touches.length !== 1) return;

//             const touch = e.touches[0];
//             const dx = touch.pageX - lastTouch.x;
//             const dy = touch.pageY - lastTouch.y;

//             // Flip directions based on platform
//             const azimuthalAngle = isMobile ? -dy * 0.005 : -dx * 0.005;
//             const polarAngle = isMobile ? dx * 0.005 : dy * 0.005;

//             controls.setAzimuthalAngle(controls.getAzimuthalAngle() - azimuthalAngle);
//             controls.setPolarAngle(controls.getPolarAngle() - polarAngle);
//             controls.update();

//             lastTouch = { x: touch.pageX, y: touch.pageY };
//         };



//         domElement.addEventListener("touchstart", onTouchStart, { passive: false });
//         domElement.addEventListener("touchmove", onTouchMove, { passive: false });

//         return () => {
//             domElement.removeEventListener("touchstart", onTouchStart);
//             domElement.removeEventListener("touchmove", onTouchMove);
//         };
//     }, [isMobile]);

//     // Update texture color space
//     useEffect(() => {
//         if (videoTexture) {
//             videoTexture.encoding = THREE.sRGBEncoding;
//             videoTexture.colorSpace = THREE.SRGBColorSpace;
//             videoTexture.needsUpdate = true;
//         }
//     }, [videoTexture]);

//     return (
//         <>
//             <Sphere args={[500, 60, 40]} scale={[-1, 1, 1]}>
//                 <meshBasicMaterial
//                     map={videoTexture || null}
//                     side={THREE.DoubleSide}
//                     color={videoTexture ? undefined : "gray"}
//                 />
//             </Sphere>

//             <OrbitControls
//                 ref={(ref) => {
//                     controlsRef.current = ref;

//                     if (typeof orbitControlsRef === "function") {
//                         orbitControlsRef(ref);
//                     } else if (orbitControlsRef) {
//                         orbitControlsRef.current = ref;
//                     }
//                 }}
//                 onChange={handleOrbitChange}
//                 enableZoom={false}
//                 rotateSpeed={-0.3}
//                 rotation={1}
//             />
//         </>
//     );
// });

// export default VideoPanoramaViewer;

import { useEffect, forwardRef, useRef } from "react";
import { OrbitControls, Sphere, useVideoTexture } from "@react-three/drei";
import * as THREE from "three";

const VideoPanoramaViewer = forwardRef(({ videoSrc, handleOrbitChange }, orbitControlsRef) => {
    const videoTexture = useVideoTexture(videoSrc, {
        loop: true,
        muted: true,
        start: true,
    });

    const controlsRef = useRef();

    // Update texture color space
    useEffect(() => {
        if (videoTexture) {
            videoTexture.encoding = THREE.sRGBEncoding;
            videoTexture.colorSpace = THREE.SRGBColorSpace;
            videoTexture.needsUpdate = true;
        }
    }, [videoTexture]);

    return (
        <>
            <Sphere args={[500, 60, 40]} scale={[-1, 1, 1]}>
                <meshBasicMaterial
                    map={videoTexture || null}
                    side={THREE.DoubleSide}
                    color={videoTexture ? undefined : "gray"}
                />
            </Sphere>

            <OrbitControls
                ref={(ref) => {
                    controlsRef.current = ref;

                    if (typeof orbitControlsRef === "function") {
                        orbitControlsRef(ref);
                    } else if (orbitControlsRef) {
                        orbitControlsRef.current = ref;
                    }
                }}
                onChange={handleOrbitChange}
                enableZoom={false}
                rotateSpeed={-0.3}
                rotation={1}
            />
        </>
    );
});

export default VideoPanoramaViewer;
